import { BlockTypeModel } from '../../../Common/PageBuilder/models/block-type.model';
import { BriefingBlockTypeApiEnum } from '../../../api/briefings/enum/briefing-block-type-api.enum';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { BriefingGeneralStylesModel } from '../models/briefing-general-styles.model';

export enum BriefingBlockTypeEnum {
    TITLE = 'title',
    TEXT = 'text',
    IMAGE = 'image',
    DATE = 'date',
    CURATED_MENTION_LIST = 'curated',
    AUTOMATIC_MENTION_LIST = 'automatic',
    ALERT_MENTIONS = 'alert_mentions',
    SURGE_ALERT = 'surge_alert',
    TABLE_OF_CONTENT = 'table_of_content',
    LAYOUT = 'layout',
    ONE_COLUMN_LAYOUT = 'one_column_layout',
    TWO_COLUMN_LAYOUT = 'two_column_layout',
    THREE_COLUMN_LAYOUT = 'three_column_layout',
    ANALYSIS = 'analysis',
    DIVIDER = 'divider',
    LINK = 'links',
    CHART = 'chart',
    COVERAGE_CURATOR = 'coverage_curator',
};

export const briefingBlockTypeEnumToApi = new Map<BriefingBlockTypeEnum, BriefingBlockTypeApiEnum>([
    [BriefingBlockTypeEnum.TITLE, BriefingBlockTypeApiEnum.TITLE],
    [BriefingBlockTypeEnum.TEXT, BriefingBlockTypeApiEnum.TEXT],
    [BriefingBlockTypeEnum.IMAGE, BriefingBlockTypeApiEnum.IMAGE],
    [BriefingBlockTypeEnum.DATE, BriefingBlockTypeApiEnum.DATE],
    [BriefingBlockTypeEnum.CURATED_MENTION_LIST, BriefingBlockTypeApiEnum.CURATED_MENTION_LIST],
    [BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST, BriefingBlockTypeApiEnum.AUTOMATIC_MENTION_LIST],
    [BriefingBlockTypeEnum.ALERT_MENTIONS, BriefingBlockTypeApiEnum.ALERT_MENTIONS],
    [BriefingBlockTypeEnum.SURGE_ALERT, BriefingBlockTypeApiEnum.SURGE_ALERT],
    [BriefingBlockTypeEnum.TABLE_OF_CONTENT, BriefingBlockTypeApiEnum.TABLE_OF_CONTENT],
    [BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT, BriefingBlockTypeApiEnum.LAYOUT],
    [BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT, BriefingBlockTypeApiEnum.LAYOUT],
    [BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT, BriefingBlockTypeApiEnum.LAYOUT],
    [BriefingBlockTypeEnum.ANALYSIS, BriefingBlockTypeApiEnum.ANALYSIS],
    [BriefingBlockTypeEnum.DIVIDER, BriefingBlockTypeApiEnum.DIVIDER],
    [BriefingBlockTypeEnum.LINK, BriefingBlockTypeApiEnum.LINK],
    [BriefingBlockTypeEnum.CHART, BriefingBlockTypeApiEnum.CHART],
    [BriefingBlockTypeEnum.COVERAGE_CURATOR, BriefingBlockTypeApiEnum.COVERAGE_CURATOR]
]);

export const briefingBlockTypeEnumFromApi = new Map<BriefingBlockTypeApiEnum, BriefingBlockTypeEnum>([
    [BriefingBlockTypeApiEnum.TITLE, BriefingBlockTypeEnum.TITLE],
    [BriefingBlockTypeApiEnum.TEXT, BriefingBlockTypeEnum.TEXT],
    [BriefingBlockTypeApiEnum.IMAGE, BriefingBlockTypeEnum.IMAGE],
    [BriefingBlockTypeApiEnum.DATE, BriefingBlockTypeEnum.DATE],
    [BriefingBlockTypeApiEnum.CURATED_MENTION_LIST, BriefingBlockTypeEnum.CURATED_MENTION_LIST],
    [BriefingBlockTypeApiEnum.AUTOMATIC_MENTION_LIST, BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST],
    [BriefingBlockTypeApiEnum.ALERT_MENTIONS, BriefingBlockTypeEnum.ALERT_MENTIONS],
    [BriefingBlockTypeApiEnum.SURGE_ALERT, BriefingBlockTypeEnum.SURGE_ALERT],
    [BriefingBlockTypeApiEnum.TABLE_OF_CONTENT, BriefingBlockTypeEnum.TABLE_OF_CONTENT],
    [BriefingBlockTypeApiEnum.LAYOUT, BriefingBlockTypeEnum.LAYOUT],
    [BriefingBlockTypeApiEnum.ANALYSIS, BriefingBlockTypeEnum.ANALYSIS],
    [BriefingBlockTypeApiEnum.DIVIDER, BriefingBlockTypeEnum.DIVIDER],
    [BriefingBlockTypeApiEnum.LINK, BriefingBlockTypeEnum.LINK],
    [BriefingBlockTypeApiEnum.CHART, BriefingBlockTypeEnum.CHART],
    [BriefingBlockTypeApiEnum.COVERAGE_CURATOR, BriefingBlockTypeEnum.COVERAGE_CURATOR]
]);

export const briefingBlockTypeEnumToStyleTypeEnum = new Map<BriefingBlockTypeEnum, StyleTypesApiEnum>([
    [BriefingBlockTypeEnum.TITLE, StyleTypesApiEnum.TITLE],
    [BriefingBlockTypeEnum.TEXT, StyleTypesApiEnum.TEXT],
    [BriefingBlockTypeEnum.IMAGE, StyleTypesApiEnum.IMAGE],
    [BriefingBlockTypeEnum.DATE, StyleTypesApiEnum.DATE],
    [BriefingBlockTypeEnum.CURATED_MENTION_LIST, StyleTypesApiEnum.CURATED_MENTION_LIST],
    [BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST, StyleTypesApiEnum.AUTOMATIC_MENTION_LIST],
    [BriefingBlockTypeEnum.ALERT_MENTIONS, StyleTypesApiEnum.ALERT],
    [BriefingBlockTypeEnum.SURGE_ALERT, StyleTypesApiEnum.SURGE_ALERT],
    [BriefingBlockTypeEnum.TABLE_OF_CONTENT, StyleTypesApiEnum.TABLE_OF_CONTENT],
    [BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT, StyleTypesApiEnum.ONE_COLUMN_LAYOUT],
    [BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT, StyleTypesApiEnum.TWO_COLUMN_LAYOUT],
    [BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT, StyleTypesApiEnum.THREE_COLUMN_LAYOUT],
    [BriefingBlockTypeEnum.ANALYSIS, StyleTypesApiEnum.ANALYSIS],
    [BriefingBlockTypeEnum.DIVIDER, StyleTypesApiEnum.DIVIDER],
    [BriefingBlockTypeEnum.LINK, StyleTypesApiEnum.LINK],
    [BriefingBlockTypeEnum.CHART, StyleTypesApiEnum.CHART],
    [BriefingBlockTypeEnum.COVERAGE_CURATOR, StyleTypesApiEnum.COVERAGE_CURATOR],
]);

export const briefingBlockTypeToGeneralStylesKey = new Map<BriefingBlockTypeEnum, keyof BriefingGeneralStylesModel>([
    [BriefingBlockTypeEnum.TITLE, 'title'],
    [BriefingBlockTypeEnum.TEXT, 'text'],
    [BriefingBlockTypeEnum.DATE, 'date'],
    [BriefingBlockTypeEnum.CURATED_MENTION_LIST, 'mention'],
    [BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST, 'mention'],
    [BriefingBlockTypeEnum.ALERT_MENTIONS, 'mention'],
    [BriefingBlockTypeEnum.TABLE_OF_CONTENT, 'tableOfContent'],
    [BriefingBlockTypeEnum.IMAGE, 'image'],
    [BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT, 'oneColumnLayout'],
    [BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT, 'twoColumnLayout'],
    [BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT, 'threeColumnLayout'],
    [BriefingBlockTypeEnum.ANALYSIS, 'analysis'],
    [BriefingBlockTypeEnum.DIVIDER, 'divider'],
    [BriefingBlockTypeEnum.LINK, 'link'],
    [BriefingBlockTypeEnum.CHART, 'image'],
    [BriefingBlockTypeEnum.COVERAGE_CURATOR, 'coverageCurator']
]);

export const styleTypeApiEnumToBriefingBlockTypeEnum = new Map<StyleTypesApiEnum, BriefingBlockTypeEnum>([
    [StyleTypesApiEnum.TITLE, BriefingBlockTypeEnum.TITLE],
    [StyleTypesApiEnum.TEXT, BriefingBlockTypeEnum.TEXT],
    [StyleTypesApiEnum.IMAGE, BriefingBlockTypeEnum.IMAGE],
    [StyleTypesApiEnum.DATE, BriefingBlockTypeEnum.DATE],
    [StyleTypesApiEnum.CURATED_MENTION_LIST, BriefingBlockTypeEnum.CURATED_MENTION_LIST],
    [StyleTypesApiEnum.AUTOMATIC_MENTION_LIST, BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST],
    [StyleTypesApiEnum.ALERT, BriefingBlockTypeEnum.ALERT_MENTIONS],
    [StyleTypesApiEnum.TABLE_OF_CONTENT, BriefingBlockTypeEnum.TABLE_OF_CONTENT],
    [StyleTypesApiEnum.ONE_COLUMN_LAYOUT, BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT],
    [StyleTypesApiEnum.TWO_COLUMN_LAYOUT, BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT],
    [StyleTypesApiEnum.THREE_COLUMN_LAYOUT, BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT],
    [StyleTypesApiEnum.ANALYSIS, BriefingBlockTypeEnum.ANALYSIS],
    [StyleTypesApiEnum.DIVIDER, BriefingBlockTypeEnum.DIVIDER],
    [StyleTypesApiEnum.LINK, BriefingBlockTypeEnum.LINK],
    [StyleTypesApiEnum.CHART, BriefingBlockTypeEnum.CHART],
    [StyleTypesApiEnum.COVERAGE_CURATOR, BriefingBlockTypeEnum.COVERAGE_CURATOR]
]);

export const columnNumberToBriefingBlockTypeMap = new Map<number, BriefingBlockTypeEnum>([
    [ 1, BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT   ],
    [ 2, BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT   ],
    [ 3, BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT ],
]);

export const isMentionBlockTypes = (blockType: BlockTypeModel) => {
    if (!blockType) {
        return false;
    }

    // I was going to put analysis block, but sometimes we don't want to include it
    return blockType.key === BriefingBlockTypeEnum.ALERT_MENTIONS
        || blockType.key === BriefingBlockTypeEnum.CURATED_MENTION_LIST
        || blockType.key === BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST;
};
